export const LINK_EXPIRED_MESSAGE = 'Este link expirou ou já foi utilizado.';
export const NOT_RESCHEDULABLE_MESSAGE = 'Este agendamento não pode mais ser remarcado.';

export const LINK_ERROR_CODES = {
	LINK_INVALID: 'LINK_INVALID',
	ATTENDANCE_NOT_FOUND: 'ATTENDANCE_NOT_FOUND',
	ATTENDANCE_NOT_RESCHEDULABLE: 'ATTENDANCE_NOT_RESCHEDULABLE'
};

export const isLinkInvalid = error => error?.code === LINK_ERROR_CODES.LINK_INVALID || error?.code === 403;

export const isNotReschedulable = error => [
	LINK_ERROR_CODES.ATTENDANCE_NOT_FOUND,
	LINK_ERROR_CODES.ATTENDANCE_NOT_RESCHEDULABLE
].includes(error?.code);

export const isScheduleLinkError = (error, scheduleLinkCode) => !!scheduleLinkCode && error?.code === LINK_ERROR_CODES.LINK_INVALID;

export const getLinkErrorMessage = (error, fallbackMessage) => {
	if (isLinkInvalid(error)) {
		return LINK_EXPIRED_MESSAGE;
	}

	if (error?.code === LINK_ERROR_CODES.ATTENDANCE_NOT_RESCHEDULABLE) {
		return NOT_RESCHEDULABLE_MESSAGE;
	}

	return fallbackMessage;
};
